import { ImportCsvRequest, ImportCsvResponse, WashingMethod } from '@/types'
import { CreateWashingMethodRequest } from '@/types/apis/washingMethods/CreateWashingMethodRequest'
import { CreateWashingMethodResponse } from '@/types/apis/washingMethods/CreateWashingMethodResponse'
import { DeleteWashingMethodRequest } from '@/types/apis/washingMethods/DeleteWashingMethodRequest'
import { DeleteWashingMethodResponse } from '@/types/apis/washingMethods/DeleteWashingMethodResponse'
import { GetAllWashingMethodResponse } from '@/types/apis/washingMethods/GetAllWashingMethodResponse'
import { GetWashingMethodRequest } from '@/types/apis/washingMethods/GetWashingMethodRequest'
import { GetWashingMethodResponse } from '@/types/apis/washingMethods/GetWashingMethodResponse'
import { UpdateWashingMethodRequest } from '@/types/apis/washingMethods/UpdateWashingMethodRequest'
import { UpdateWashingMethodResponse } from '@/types/apis/washingMethods/UpdateWashingMethodResponse'

import axios from './axios'

const API_ENDPOINT = '/washing-method'

export const getAllWashingMethod = ({
  limit,
  page,
}: {
  limit?: number
  page?: number
}): Promise<GetAllWashingMethodResponse> => {
  return axios.get(`${API_ENDPOINT}?limit=${limit}&page=${page}`)
}

export const getWashingMethodsApi = (): Promise<WashingMethod[]> => {
  return axios.get(`${API_ENDPOINT}/all`)
}

export const getWashingMethod = (request?: GetWashingMethodRequest): Promise<GetWashingMethodResponse> => {
  return axios.get(`${API_ENDPOINT}/${request?.id}`)
}

export const createWashingMethod = (request: CreateWashingMethodRequest): Promise<CreateWashingMethodResponse> => {
  return axios.post(API_ENDPOINT, request)
}

export const updateWashingMethod = (request: UpdateWashingMethodRequest): Promise<UpdateWashingMethodResponse> => {
  return axios.put(`${API_ENDPOINT}/${request.id}`, request)
}

export const deleteWashingMethod = (request: DeleteWashingMethodRequest): Promise<DeleteWashingMethodResponse> => {
  return axios.delete(`${API_ENDPOINT}/${request.id}`)
}

export const importCsvWashingMethodApi = (request: ImportCsvRequest): Promise<ImportCsvResponse> => {
  return axios.post(`${API_ENDPOINT}/import-csv`, request)
}
